var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reset-password"},[(_vm.isForm)?_c('ResetPasswordForm',{on:{"success":function($event){_vm.isForm = false}}}):_c('ResetPasswordSuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }